export default [
  {
    path: "/auth",
    name: "Auth",
    redirect: { name: "Login" },
    component: () => import("../views/layouts/UnAuthenticated.vue"),
    children: [
      {
        path: "/login",
        name: "Login",
        component: () => import("../views/pages/auth/Login.vue"),
        meta: { title: "Login" }
      },
      {
        path: "/forget-password",
        name: "ForgetPassword",
        component: () => import("../views/pages/auth/ForgetPassword.vue"),
        meta: { title: "Forget password" }
      },
      {
        path: "/invite",
        name: "InvitePublic",
        component: () => import("../views/pages/auth/InvitePublic.vue"),
        meta: { title: "Invite", allowUnauthenticated: true }
      }
    ]
  }
]
